import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Produit } from '../model/produit';

@Injectable({
    providedIn: 'root'
  })
  export class ProduitService{
  
  constructor(private _restClientService : RestClientService) 
  {}
  
  getAllProduits() 
  {
    return this._restClientService.load<Produit[]>('produit/produits');
  }
    
  getListproduitByTypeCredit(typeId) 
  {
    return this._restClientService.load<Produit[]>('produit/produits-by-type-credit?requestTypeId='+typeId);
  }

  update(produit) {
    return  this._restClientService.put<Produit>(`produit/update-produit`, produit);
  }
  
  add(produit) {
    return  this._restClientService.save<Produit>('produit/add-produit', produit);
  }
  
  getProduitById(produitId)
  {
    return this._restClientService.load<Produit>('produit/produit-by-id/'+produitId);
  }



  

}      

    